import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BsDatepickerConfig, BsDatepickerInlineConfig } from 'ngx-bootstrap/datepicker';
import { VisibleDateRange } from './visible-date-range';

@Component({
  selector: 'rl-visible-date-range',
  templateUrl: './visible-date-range.component.html',
  styleUrls: ['./visible-date-range.component.scss'],
  providers: [
    {
      provide : NG_VALUE_ACCESSOR,
      multi : true,
      useExisting: VisibleDateRangeComponent
    }
  ]
})
export class VisibleDateRangeComponent implements OnInit, ControlValueAccessor {

  constructor() { }

  @Input() labelPre : string = '';

  item : VisibleDateRange = new VisibleDateRange();;

  dateConfig : Partial<BsDatepickerConfig> = {
    showTodayButton : true,
    //showClearButton : true,
    dateInputFormat : 'MM/DD/YYYY',
    returnFocusToInput : true
  };

  ngOnInit(): void {
  }

  writeValue(obj: any[]): void {
    //throw exception
    this.item.start = obj[0] ? new Date(obj[0]) : '';
    this.item.end = obj[1] ? new Date(obj[1]) : '';
    this.item.isVisibleBetweenDates = obj[2];
  }

  onChange = (item : VisibleDateRange) => this.item;
  
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    //throw new Error('Method not implemented.');
  }
  setDisabledState?(isDisabled: boolean): void {
    //throw new Error('Method not implemented.');
  }

}
